module.exports = __webpack_public_path__ + "img/IMG_3450_L_Foamcore_MockedUp.647f04b8.jpg";